/**
 * 主入口文件， 请勿随意删改！！！
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

/* 导入区域 */
// 导入指令
import directives from './directives';
// 导入全局组件
import './components/global';
// 导入自定义样式
import './styles/index.scss';
// 导入字体文件
import './assets/icons/iconfont.css';
// 导入隐藏类
import 'element-ui/lib/theme-chalk/display.css';
// 导入插件
import plugins from '@/plugins';
// 导入阿里日志
import '@/libs/loghub-tracking.js';
// import '@/plugins/oss';
// 过滤器
import filters from '@/filters';
// 注册过滤器
Object.keys(filters).forEach(e => {
	Vue.filter(e, filters[e]);
});
// 导入语言包
import i18n from './i18n';

// 阻止 vue 在启动时生成生产提示。 请勿删改！！！
Vue.config.productionTip = false;

// 引入voidejs 萌萌播使用
import Videojs from 'video.js';
import 'video.js/dist/video-js.css';

Vue.prototype.$video = Videojs;
// 注册指令
directives(Vue);
// 注册插件
plugins(Vue);
/* 调试区域 */

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
